<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/manageSys' }">管理制度</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <p class="doc_txt">系统管理制度</p>
            <p class="doc_txt01">2022-10-13</p>
            <!-- <div class="doc_btn">
                <el-button type="success" size="small" @click="onDownloadFile">下载</el-button>
            </div> -->
            <div class="p_pdf_box">
                <p class="doc_txt02">
                    <i class="el-icon-paperclip"></i>
                    <span>文档附件</span>
                </p>
                <p class="doc_txt03" title="" @click="onDownloadFile">
                    <i class="el-icon-document"></i>
                    <span>杰博数字化系统管理制度</span>
                    <span class="doc_txt04">(108k)</span>
                </p>
            </div>
            <!-- <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="使用指南"></el-tab-pane>
            </el-tabs> -->
        </div>
    </div>
  </div>
</template>

<script>
import { download } from '@/utils' //封装的下载方法
export default {
  data() {
    return {
        src: '', // pdf文件页码
    }
  },
  created() {
    let comPath = location.origin + '/cloudimg/helpfile/%E6%9D%B0%E5%8D%9A%E6%95%B0%E5%AD%97%E5%8C%96%E7%B3%BB%E7%BB%9F%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A61.0.pdf'
    this.src = comPath
  },
  mounted() {
    
  },
  methods: {
    //下载
    onDownloadFile() {
        this.$router.push({ 
            path: '/dtlDocPdf'})
    }
  }
};
</script>

<style>
.p_doc_content{
    padding: 20px;
    background-color: #fff;
}
</style>
<style scoped>
.doc_txt01{
    color:#999;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
    padding: 0 0 10px;
    border-bottom: 1px dashed #ddd;
}
.doc_txt02 {
    font-size: 16px;
    color:#999;
    margin-top: 15px;
}
.doc_txt03 {
    font-size: 16px;
    color:#19bd92;
    margin-top: 15px;
    cursor: pointer;
}
.doc_txt03 i{
    font-size: 16px;
    color:#19bd92;
    margin-right: 5px;
}
.doc_txt03 .doc_txt04 {
    font-size: 16px;
    color:#999;
    margin-left: 15px;
}
.doc_txt02 i{
    font-size: 16px;
    color:#999;
    margin-right: 5px;
}
.p_doc_content .doc_txt{
    text-align: center;
    font-size: 16px;
    color:#333;
}
.doc_btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.el-pagination{
  background-color: #fff;
}
</style>